import { ITipoRelacaoCliente } from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoRelacaoCliente/TipoRelacaoClienteInterface";
import Axios from "../../../Config/API";
import Service from "../../../Service";

export async function ListarTipoRelacaoClienteService() {
    return Service(
        Axios.get<Array<ITipoRelacaoCliente>>(
            `/home/tiporelacaocliente/listartiporelacaocliente`
        )
    );
}

export async function AlterarTipoRelacaoClienteService(
    requestBody: ITipoRelacaoCliente
) {
    return Service(
        Axios.put(
            `/home/tiporelacaocliente/atualizartiporelacaocliente`,
            requestBody
        )
    );
}
